const messageCache = {
  messages: []
};

export default messageCache;
